import { ChannelStatus } from '../enums/ChannelStatus';
import { ChatAction } from '../interfaces/ITwilioMessage';
import { CrossFrameMessageType } from '../lib/postMessage';
import ChatStore from './ChatStore';

export const MockTwilioCustomerMessage = {
  attributes: {
    name: 'You',
  },
  author: 'you-123',
  body: 'Customer sends a message.',
  index: 0,
  timestamp: new Date(),
  type: 'text',
};

export const MockTwilioAgentMessage = {
  attributes: {
    name: 'Agent',
  },
  author: 'agent-007',
  body: 'Agent or bot responds with a message after initiating a chat then will end the chat after a few seconds.',
  index: 1,
  timestamp: new Date(),
  type: 'text',
};

const MockTwilioAgentEndsChatMessage = {
  attributes: {
    name: 'Agent',
    actions: [
      {
        action: ChatAction.EndingChat,
        name: 'Agent',
        payload: {},
      },
    ],
  },
  author: 'agent-007',
  body: '',
  index: 2,
  timestamp: new Date(),
  type: 'text',
};

class MockChatStore extends ChatStore {
  public async sendMessageWithGreeting() {
    if (this.status !== ChannelStatus.Active) {
      this.status = ChannelStatus.Waiting;
      postMessage(CrossFrameMessageType.ChatInitiated);
    }

    // Not sure how to emit the event so we're just going to directly call these methods:

    this.onMessageAdd(MockTwilioCustomerMessage);

    // Simulate agent response after a few seconds
    setTimeout(async () => {
      this.memberJoined(MockTwilioAgentMessage.author);
      await this.onMessageAdd(MockTwilioAgentMessage);
      await this.onMessageAdd(MockTwilioAgentEndsChatMessage);
      this.memberLeft({
        channel: {
          members: {
            size: 1,
          },
        },
      });
    }, 3000);
  }
}

export default MockChatStore;
